module.exports = __webpack_public_path__ + "static/media/classicos_feminino_roupas.df9c810b.jpg";